import { display } from './display';
export function catchUserErrors(fn, errorMsg) {
  return function () {
    try {
      return fn.apply(void 0, arguments);
    } catch (err) {
      display.error(errorMsg, err);
    }
  };
}